import React from "react";
import {BrowserRouter as Router, Switch, Route, Redirect} from "react-router-dom";

// Libs
import {ProvideAuth, useAuth} from "../auth/auth";
import {ProvideFilters} from "../filters/filters";
import {ProvideUserClientsData} from "../user-clients-data/user-clients-data";

// Components
import AppLayout from "./app-layout";
import ForgotPage from "../forgot/forgot-page";
import LoginPage from "../login/login-page";
import PrivateAppRoutes from "./private-app-routes";
import ProfilePage from "../profile/profile-page";
import PublicLayout from "./public-layout";
import ResetPasswordPage from "../reset-password/reset-password-page";
import WelcomePage from "../welcome/welcome-page";

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
const PrivateRoute = ({children, ...rest}) => {
    const auth = useAuth();
    return (
        <Route
            {...rest}
            render={({location}) =>
                auth.isLoggedIn ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: {from: location}
                        }}
                    />
                )
            }
        />
    );
};

const PublicRoute = ({children, ...rest}) => {
    const auth = useAuth();
    return (
        <Route
            {...rest}
            render={({location}) =>
                !auth.isLoggedIn ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/",
                            state: {from: location}
                        }}
                    />
                )
            }
        />
    );
};

const AppRoutes = () => {
    return (
        <ProvideAuth>
            <ProvideFilters>
                <ProvideUserClientsData>
                    <Router>
                        <Switch>
                            <PublicRoute path="/login">
                                <PublicLayout>
                                    <LoginPage/>
                                </PublicLayout>
                            </PublicRoute>
                            <PublicRoute path="/welcome">
                                <PublicLayout>
                                    <WelcomePage/>
                                </PublicLayout>
                            </PublicRoute>
                            <PublicRoute path="/reset-password">
                                <PublicLayout>
                                    <ResetPasswordPage />
                                </PublicLayout>
                            </PublicRoute>
                            <PublicRoute path="/forgot">
                                <PublicLayout>
                                    <ForgotPage/>
                                </PublicLayout>
                            </PublicRoute>
                            <PrivateRoute path="/profile">
                                <AppLayout>
                                    <ProfilePage/>
                                </AppLayout>
                            </PrivateRoute>
                            <PrivateRoute path="/">
                                <AppLayout>
                                    <PrivateAppRoutes/>
                                </AppLayout>
                            </PrivateRoute>
                        </Switch>
                    </Router>
                </ProvideUserClientsData>
            </ProvideFilters>
        </ProvideAuth>
    );
};

export default AppRoutes;
